<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />
    <link rel="stylesheet" type="text/css" href="/css/integrations.css" />

    <script>

        window.fbAsyncInit = function() {

            FB.init({
                appId      : '183687366269938',
                cookie     : true,
                xfbml      : true,
                version    : 'v9.0'
            });

            FB.AppEvents.logPageView();

        };

        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    </script>

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { createEventDispatcher } from "svelte";

    import {
        errorReasons,
        facebookAuth,
        facebookPages
    } from "../api.svelte";


    const dispatch = createEventDispatcher();

    export let propertyId;
    export let data = false;

    let facebookAuthenticated = false;
    let pages = false;

    $: isLinked = () => {

        if (!data) return false;

        return Object.keys(data).includes('name');

    };


    onMount(() => {

        //

    });

    let handler = () => {};

    let authHandler = () => {

        FB.login((response) => {

            if (!response.authResponse) {

                // TODO: Handle errore
                console.log(response);
                return;

            }

            facebookAuthenticate(response.authResponse);

        }, { scope: 'manage_pages' });

    };

    let facebookAuthenticate = (auth) => {

        if (facebookAuthenticated) {

            getPages();
            return;

        }

        facebookAuth(propertyId, auth.accessToken, auth.userId).then((authResult) => {

            if (authResult['status'] !== 'success') {

                // TODO: Handle errore
                console.log(authResult);
                return;

            }

            facebookAuthenticated = true;

            getPages();

        });

    };

    let getPages = () => {

        facebookPages(propertyId).then((pagesResult) => {

            if (pagesResult['status'] !== 'success') {

                // TODO: Handle errore
                console.log(pagesResult);
                return;

            }

            let facebookPages = [];

            for (const [pageKey, page] of Object.entries(pagesResult['pages'])) {

                let pageItem = {
                    'id': page['id'],
                    'token': page['token'],
                    'name': page['name']
                };

                if (facebookPages.includes(pageItem)) {

                    continue;
                }

                facebookPages.push(pageItem);

            }

            pages = facebookPages;

        });

    };

    let onClosed = () => {

        dispatch('closed');
    };

    let onDeleted = () => {

        dispatch('deleted', {
            integration: 'facebook'
        });

    };

    let onSelected = (id, token, name) => {

        pages = false;

        dispatch('selected', {
            id: id,
            token: token,
            name: name
        });

    };

</script>


<form on:submit|preventDefault={() => handler()} id="facebookform" class="forms">

    <div class="form-header">

        <img src="/images/icons/integrations/facebook.svg" />

        <span class="form-title">Facebook</span>

    </div>

    {#if !isLinked()}

        {#if !pages}

            <div id="facebook-authentication">

                <button
                        class="btn-login btn-facebook"
                        on:click|preventDefault={() => authHandler()} >

                    <img src="/images/icons/integrations/login-facebook.png" />
                    <span>Mit Facebook anmelden</span>

                </button>

            </div>

            <div class="integration-buttons single">

                <button
                        class="btn half"
                        on:click|preventDefault={() => onClosed()} >

                    <span>Abschliessen</span>

                </button>

            </div>

        {:else}

            <div id="facebook-pages">

                <div id="pages-title">Wählen Sie eine Facebook Seite</div>

                <div id="pages-results">

                    {#if pages.length < 1}

                        <div class="pages-item">

                            <span class="item-name">Keine Ergebnisse.</span>

                        </div>

                    {/if}

                    {#each pages as item}

                        <div
                                class="locations-item"
                                on:click={() => onSelected(item['id'], item['token'], item['name'])}>

                            <span class="item-name">{item['name']}</span>

                        </div>

                    {/each}

                </div>

            </div>

            <div class="integration-buttons single">

                <button
                        class="btn half"
                        on:click|preventDefault={() => pages = false} >

                    <span>Abschliessen</span>

                </button>

            </div>

        {/if}

    {:else}

        <div class="integration-view">

            <span id="title">{data['name']}</span>

        </div>

        <div class="integration-buttons">

            <button
                    class="btn danger half"
                    on:click|preventDefault={() => onDeleted()} >

                <span>Entfernen</span>

            </button>

            <button
                    class="btn half"
                    on:click|preventDefault={() => onClosed()} >

                <span>Abschliessen</span>

            </button>

        </div>

    {/if}

</form>


<style>

    .form-header img {
        width: 3.33vh;
        margin-right: 1.2vh;
    }

    button.btn-login.btn-facebook {
        display: flex;
        align-items: center;
        width: 31vh;
        padding: 1.8vh;
        background-color: #1877f2;
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        color: white;
        border-radius: 5px;
    }

    .btn-facebook img {
        width: 1.8vh;
        height: 1.8vh;
        margin-right: 0.9vh;
    }

    .btn-facebook span {
        width: 28.3vh;
        font-size: 1.6vh;
    }

    #pages-title {
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
        font-size: 1.48vh;
        text-align: left;
    }

    #pages-results {
        display: flex;
        flex-direction: column;
        max-height: 20vh;
        margin-top: 2.12vh;
    }

    .pages-item {
        display: flex;
        flex-direction: column;
        width: 31vh;
        padding: 1.42vh;
        margin-bottom: 2.12vh;
        z-index: 9;
        font-size: 1.5vh;
        font-family: 'Raleway', sans-serif;
        text-align: left;
        cursor: pointer;
        border-radius: 1vh;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
    }

    .pages-item:last-child {
        margin-bottom: 0;
    }

    .pages-item .item-name {
        font-weight: 500;
    }

</style>
